<template>
  <div @scroll.passive="handleScroll">
    <the-header :show-searchbar="showSearchbar" />
    <div class="router-wrapper">
      <router-view />
    </div>
    <the-footer />
  </div>
</template>

<script>
import TheFooter from "@/components/TheFooter";
import TheHeader from "@/components/TheHeader";
import RouteNames from "@/constants/router/route-names";

const searchbarOffset = 346;

export default {
  name: "MainLayout",

  components: {
    TheFooter,
    TheHeader
  },

  data() {
    return {
      showSearchbar: false
    };
  },

  watch: {
    $route() {
      this.shouldHandleScroll();
    }
  },

  created() {
    this.shouldHandleScroll();
  },

  destroyed() {
    this.removeScroll();
  },

  methods: {
    shouldHandleScroll() {
      if (this.$route.name === RouteNames.HOME) {
        this.handleScroll();
        this.addScroll();
      } else {
        this.removeScroll();
      }
    },

    handleScroll() {
      if (window.pageYOffset >= searchbarOffset) {
        this.showSearchbar = true;
      } else {
        this.showSearchbar = false;
      }
    },

    addScroll() {
      window.addEventListener("scroll", this.handleScroll);
    },

    removeScroll() {
      window.removeEventListener("scroll", this.handleScroll);
      this.showSearchbar = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.router-wrapper {
  margin-top: 52px;
}

@media only screen and (min-width: 1024px) {
  .router-wrapper {
    margin-top: 138px;
  }
}
</style>
